import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IEmisor } from './emisor';
import { catchError, tap, map } from 'rxjs/operators';
import * as myGlobals from './../global';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class EmisoresService {
  private _emisoresURL = myGlobals.baseApi + '/webadmin/v1/card-issuers';
  private _activeURL = myGlobals.baseApi + '/webadmin/v1/card-issuers';

  constructor(private http: HttpClientSecured) {}

  getEmisores() {
    return this.http.get<any>(this._emisoresURL);
  }

  getEmisor(itemid: number): Observable<IEmisor | undefined> {
    return this.getEmisores().pipe(map((emisores: IEmisor[]) => emisores.find(p => p.id === itemid)));
  }

  getActiveEmisores(): Observable<IEmisor[]> {
    return this.http.get<IEmisor[]>(this._activeURL).pipe(
      tap(data => console.log('AllActive: ' + JSON.stringify(data))),
      catchError(this.handleError)
    );
  }
  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
